(function () {
  'use strict';

  var submitTimer = null;
  var sidebarFrame = null;
  var lastDesktopState = null;
  var activeController = null;
  var requestId = 0;
  var syncingGroupState = false;
  var mobileDrawerObserver = null;
  var enhancementObserver = null;
  var enhancementIdleHandle = null;
  var collectionCache = new Map();
  var partialRenderingDisabled = false;
  var loadingVisualTimer = null;
  var collectionRequestFailSafe = null;
  var COLLECTION_REQUEST_TIMEOUT = 15000;
  var priceUniformChecks = new Map();
  var priceUniformControllers = new Set();
  var lastInputModality = 'pointer';
  var resultsPositionFrame = null;
  var resultsPositionSettleFrame = null;

  var LOADING_VISUAL_DELAY = 280;

  var COLLECTION_CACHE_TTL = 120000;
  var COLLECTION_CACHE_LIMIT = 6;

  var HIDDEN_KEY = 'es_collection_filters_hidden_v1';
  var GROUPS_KEY_PREFIX = 'es_collection_filter_groups_v1:';
  var PRICE_UNIFORM_CACHE_KEY = 'es_collection_price_uniform_v1392';
  var PRICE_UNIFORM_CACHE_TTL = 30000;

  function isDesktop() {
    if (window.ES && window.ES.media && typeof window.ES.media.matches === 'function') {
      return window.ES.media.matches('(min-width: 1200px)', (window.innerWidth || 0) >= 1200);
    }
    return window.matchMedia && window.matchMedia('(min-width: 1200px)').matches;
  }

  function storageGet(key) {
    try { return window.localStorage ? window.localStorage.getItem(key) : null; }
    catch (e) { return null; }
  }

  function storageSet(key, value) {
    try { if (window.localStorage) window.localStorage.setItem(key, value); }
    catch (e) {}
  }

  
  function readGroupStates(context) {
    try {
      var value = storageGet(GROUPS_KEY_PREFIX + context);
      return value ? JSON.parse(value) : {};
    } catch (e) {
      return {};
    }
  }

  function writeGroupState(context, kind, open) {
    if (!kind) return;
    var states = readGroupStates(context);
    states[kind] = !!open;
    storageSet(GROUPS_KEY_PREFIX + context, JSON.stringify(states));
  }

  function setSidebarHidden(hidden, persist) {
    hidden = !!hidden && isDesktop();
    document.documentElement.classList.toggle('es-filters-hidden', hidden);
    document.querySelectorAll('[data-es-hide-filters]').forEach(function (button) {
      button.setAttribute('aria-expanded', hidden ? 'false' : 'true');
    });
    document.querySelectorAll('[data-es-show-filters]').forEach(function (button) {
      button.setAttribute('aria-expanded', hidden ? 'false' : 'true');
    });
    if (persist) storageSet(HIDDEN_KEY, hidden ? '1' : '0');
    updateDesktopSidebarHeight();
    try { if (window.ES_applyCollectionCols) window.ES_applyCollectionCols(); } catch (e) {}
  }

  function restoreSidebarHidden() {
    setSidebarHidden(storageGet(HIDDEN_KEY) === '1', false);
  }

  function updateDesktopSidebarHeight() {
    if (!isDesktop()) return;
    if (sidebarFrame) window.cancelAnimationFrame(sidebarFrame);
    sidebarFrame = window.requestAnimationFrame(function () {
      document.querySelectorAll('.es-native-filter-desktop').forEach(function (sidebar) {
        if (sidebar.offsetParent === null) return;
        var rect = sidebar.getBoundingClientRect();
        var visibleTop = Math.max(rect.top, 78);
        var available = Math.max(330, window.innerHeight - visibleTop - 18);
        sidebar.style.setProperty('--es-filter-viewport-height', available + 'px');
      });
    });
  }

  function initSidebarWheel() {
    document.querySelectorAll('.es-native-filter-desktop').forEach(function (sidebar) {
      if (sidebar.dataset.esWheelReady === '1') return;
      sidebar.dataset.esWheelReady = '1';
      sidebar.addEventListener('wheel', function (event) {
        if (sidebar.scrollHeight <= sidebar.clientHeight) return;
        event.preventDefault();
        event.stopPropagation();
        sidebar.scrollTop += event.deltaY;
      }, { passive: false });
    });
  }

  function formatMinorAmount(cents, minorUnit) {
    var unit = Math.max(1, Number(minorUnit) || 100);
    var amount = Math.max(0, Math.round(Number(cents) || 0)) / unit;
    if (unit === 100) return amount.toFixed(2).replace(/\.00$/, '');
    return String(amount);
  }

  function moneyLabel(symbol, cents, minorUnit, plus) {
    return symbol + formatMinorAmount(cents, minorUnit) + (plus ? '+' : '');
  }

  function priceParamFromCents(cents, minorUnit) {
    return formatMinorAmount(cents, minorUnit);
  }

  function readOptionalCents(value) {
    if (value === undefined || value === null || String(value).trim() === '') return null;
    var cents = Math.round(Number(value));
    return Number.isFinite(cents) ? Math.max(0, cents) : null;
  }

  function syncPriceOverflowControls(root, preservedMin, preservedMax, symbol, minorUnit) {
    var wrap = root.querySelector('[data-es-price-overflow]');
    var clearMin = root.querySelector('[data-es-price-clear-min]');
    var clearMax = root.querySelector('[data-es-price-clear-max]');

    if (clearMin) {
      clearMin.hidden = preservedMin === null;
      if (preservedMin !== null) {
        clearMin.textContent = 'Clear lower limit ' + moneyLabel(symbol, preservedMin, minorUnit, false);
      }
    }
    if (clearMax) {
      clearMax.hidden = preservedMax === null;
      if (preservedMax !== null) {
        clearMax.textContent = 'Clear upper limit ' + moneyLabel(symbol, preservedMax, minorUnit, false);
      }
    }
    if (wrap) wrap.hidden = preservedMin === null && preservedMax === null;
  }

  function updatePriceRange(root, changedInput) {
    if (!root) return;
    var minInput = root.querySelector('[data-es-price-min]');
    var maxInput = root.querySelector('[data-es-price-max]');
    var hiddenMin = root.querySelector('[data-es-price-hidden-min]');
    var hiddenMax = root.querySelector('[data-es-price-hidden-max]');
    var minLabel = root.querySelector('[data-es-price-min-label]');
    var maxLabel = root.querySelector('[data-es-price-max-label]');
    var control = root.querySelector('.es-native-filter__range-control');
    if (!minInput || !maxInput || !hiddenMin || !hiddenMax || !control) return;

    var uiValueMax = Math.max(0, Math.round(Number(root.dataset.esUiValueMaxCents || minInput.max || 0)));
    var maxSentinel = Math.max(uiValueMax, Math.round(Number(root.dataset.esMaxSentinelCents || maxInput.max || uiValueMax)));
    var minSliderMax = Math.max(0, Math.round(Number(minInput.max || uiValueMax)));
    var maxSliderMax = Math.max(0, Math.round(Number(maxInput.max || maxSentinel)));
    var softMaxEnabled = root.dataset.esSoftMaxEnabled === 'true';
    var minorUnit = Math.max(1, Number(root.dataset.esMinorUnit || 100));
    var symbol = root.dataset.esCurrency || '$';
    var minValue = Math.max(0, Math.min(minSliderMax, Math.round(Number(minInput.value || 0))));
    var maxValue = Math.max(0, Math.min(maxSliderMax, Math.round(Number(maxInput.value || maxSentinel))));
    var preservedMin = readOptionalCents(root.dataset.esPreservedMinCents);
    var preservedMax = readOptionalCents(root.dataset.esPreservedMaxCents);

    var minChanged = changedInput === minInput;
    var maxChanged = changedInput === maxInput;

    // If an imported URL has a lower bound above the soft range, selecting a finite upper
    // bound must retire that preserved lower bound rather than submit an impossible gte > lte.
    if (changedInput && maxChanged && preservedMin !== null && maxValue < maxSentinel && preservedMin > maxValue) {
      minValue = Math.min(minValue, maxValue);
      minChanged = true;
    }

    if (changedInput && minValue > maxValue) {
      if (minChanged) {
        maxValue = minValue;
        maxChanged = true;
      } else {
        minValue = maxValue;
        minChanged = true;
      }
    }

    minInput.value = String(minValue);
    maxInput.value = String(maxValue);

    // Initialization paints the controls only. Existing Shopify URL fields stay byte-for-byte
    // represented by the hidden inputs until the customer moves the related handle or clears it.
    if (changedInput) {
      root.dataset.esPriceDirty = 'true';
      if (minChanged) {
        preservedMin = null;
        root.dataset.esPreservedMinCents = '';
        hiddenMin.value = minValue <= 0 ? '' : priceParamFromCents(minValue, minorUnit);
      }
      if (maxChanged) {
        preservedMax = null;
        root.dataset.esPreservedMaxCents = '';
        hiddenMax.value = maxValue >= maxSentinel ? '' : priceParamFromCents(maxValue, minorUnit);
      }
    }

    var pctBase = maxSliderMax || 1;
    var minPct = maxSliderMax ? (minValue / pctBase) * 100 : 0;
    var maxPct = maxSliderMax ? (maxValue / pctBase) * 100 : 100;
    control.style.setProperty('--es-min-pct', minPct + '%');
    control.style.setProperty('--es-max-pct', maxPct + '%');

    var displayMin = preservedMin !== null ? preservedMin : minValue;
    var maxIsUnlimited = preservedMax === null && maxValue >= maxSentinel;
    var displayMax = preservedMax !== null ? preservedMax : maxValue;

    if (minLabel) minLabel.textContent = moneyLabel(symbol, displayMin, minorUnit, false);
    if (maxLabel) {
      maxLabel.textContent = softMaxEnabled && maxIsUnlimited
        ? moneyLabel(symbol, uiValueMax, minorUnit, true)
        : moneyLabel(symbol, displayMax, minorUnit, false);
    }

    minInput.setAttribute('aria-valuetext', moneyLabel(symbol, displayMin, minorUnit, false) + ' minimum');
    if (preservedMax !== null) {
      maxInput.setAttribute('aria-valuetext', moneyLabel(symbol, preservedMax, minorUnit, false) + ' maximum; above the visual slider range');
    } else if (softMaxEnabled && maxIsUnlimited) {
      maxInput.setAttribute('aria-valuetext', moneyLabel(symbol, uiValueMax, minorUnit, true) + '; no upper price limit');
    } else {
      maxInput.setAttribute('aria-valuetext', moneyLabel(symbol, displayMax, minorUnit, false) + ' maximum');
    }

    syncPriceOverflowControls(root, preservedMin, preservedMax, symbol, minorUnit);
  }

  function clearPreservedPrice(root, side) {
    if (!root) return;
    var input;
    if (side === 'min') {
      input = root.querySelector('[data-es-price-min]');
      root.dataset.esPreservedMinCents = '';
      if (input) input.value = '0';
    } else {
      input = root.querySelector('[data-es-price-max]');
      root.dataset.esPreservedMaxCents = '';
      if (input) input.value = String(root.dataset.esMaxSentinelCents || input.max || '0');
    }
    if (input) updatePriceRange(root, input);
  }

  function initPriceRanges(scope) {
    var base = scope && scope.querySelectorAll ? scope : document;
    base.querySelectorAll('[data-es-price-range]').forEach(function (root) {
      var collectionRoot = root.closest ? root.closest('.collection-page-fullwidth') : null;
      if (collectionRoot && (
        collectionRoot.classList.contains('es-price-uniform-checking') ||
        (collectionRoot.dataset.esPriceUniform === 'true' && !hasActivePriceParameters())
      )) return;
      if (root.dataset.esPriceInitialized === '1') return;
      updatePriceRange(root, null);
      root.dataset.esPriceInitialized = '1';
    });
  }

  function readPriceUniformCache() {
    try {
      var parsed = JSON.parse(storageGet(PRICE_UNIFORM_CACHE_KEY) || '{}');
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (e) {
      return {};
    }
  }

  function getCachedPriceUniform(key) {
    var cache = readPriceUniformCache();
    var item = cache[key];
    if (!item || (Date.now() - Number(item.time || 0)) > PRICE_UNIFORM_CACHE_TTL) return null;
    return !!item.uniform;
  }

  function setCachedPriceUniform(key, uniform) {
    var cache = readPriceUniformCache();
    cache[key] = { uniform: !!uniform, time: Date.now() };
    Object.keys(cache).forEach(function (cacheKey) {
      if ((Date.now() - Number(cache[cacheKey] && cache[cacheKey].time || 0)) > PRICE_UNIFORM_CACHE_TTL) delete cache[cacheKey];
    });
    storageSet(PRICE_UNIFORM_CACHE_KEY, JSON.stringify(cache));
  }

  function getCollectionRangeMax(collectionRoot) {
    if (!collectionRoot) return NaN;
    var rootRaw = collectionRoot.dataset.esPriceRangeMaxCents;
    if (rootRaw !== undefined && rootRaw !== null && String(rootRaw).trim() !== '') {
      var rootValue = Math.round(Number(rootRaw));
      if (Number.isFinite(rootValue)) return rootValue;
    }
    var range = collectionRoot.querySelector('[data-es-price-range]');
    if (!range) return NaN;
    var value = Math.round(Number(range.dataset.esActualMaxCents));
    return Number.isFinite(value) ? value : NaN;
  }

  function getCollectionProductCount(collectionRoot) {
    if (!collectionRoot) return 0;
    var value = Math.round(Number(collectionRoot.dataset.esCollectionCount));
    return Number.isFinite(value) && value >= 0 ? value : 0;
  }

  function getPriceUniformKey(collectionRoot, collectionUrl) {
    var path = new URL(collectionUrl, window.location.origin).pathname;
    var count = getCollectionProductCount(collectionRoot);
    var max = getCollectionRangeMax(collectionRoot);
    return path + '|count:' + String(count) + '|max:' + (Number.isFinite(max) ? String(max) : 'unknown');
  }

  function setPriceAuditPending(collectionRoot, pending) {
    if (!collectionRoot) return;
    collectionRoot.classList.toggle('es-price-uniform-checking', !!pending);
  }

  function setUniformPriceVisibility(collectionRoot, uniform) {
    if (!collectionRoot) return;
    setPriceAuditPending(collectionRoot, false);
    collectionRoot.dataset.esPriceUniform = uniform ? 'true' : 'false';
    var keepActivePriceVisible = !!uniform && hasActivePriceParameters();
    var hidePrice = !!uniform && !keepActivePriceVisible;
    collectionRoot.querySelectorAll('[data-es-filter-kind="price"]').forEach(function (group) {
      group.hidden = hidePrice;
      group.setAttribute('aria-hidden', hidePrice ? 'true' : 'false');
      group.querySelectorAll('input').forEach(function (input) {
        input.disabled = hidePrice;
      });
    });
    if (!hidePrice) initPriceRanges(collectionRoot);
    updateDesktopSidebarHeight();
  }

  function currentPageCouldBeUniform(collectionRoot) {
    var cards = collectionRoot.querySelectorAll('[data-es-product-price-min-cents][data-es-product-price-max-cents]');
    if (!cards.length) return true;
    var first = null;
    for (var i = 0; i < cards.length; i += 1) {
      var min = Math.round(Number(cards[i].dataset.esProductPriceMinCents));
      var max = Math.round(Number(cards[i].dataset.esProductPriceMaxCents));
      if (!Number.isFinite(min) || !Number.isFinite(max) || min !== max) return false;
      if (first === null) first = min;
      else if (min !== first) return false;
    }
    return true;
  }

  function hasActivePriceParameters() {
    var params = new URL(window.location.href).searchParams;
    var active = false;
    params.forEach(function (value, key) {
      if (value && (key === 'filter.v.price.gte' || key === 'filter.v.price.lte')) active = true;
    });
    return active;
  }

  function parsePriceAuditPayload(text) {
    var payload;
    try { payload = JSON.parse(String(text || '').trim()); }
    catch (_err) { return null; }
    if (!payload || typeof payload !== 'object') return null;

    if (payload.count === null || payload.count === undefined ||
        payload.min === null || payload.min === undefined ||
        payload.max === null || payload.max === undefined ||
        payload.rangeMax === null || payload.rangeMax === undefined) return null;

    var count = Math.round(Number(payload.count));
    var min = Math.round(Number(payload.min));
    var max = Math.round(Number(payload.max));
    var rangeMax = Math.round(Number(payload.rangeMax));
    if (!Number.isFinite(count) || count < 0) return null;
    if (!Number.isFinite(min) || !Number.isFinite(max) || !Number.isFinite(rangeMax)) return null;
    return { count: count, min: min, max: max, rangeMax: rangeMax };
  }

  function abortPriceUniformAudits() {
    priceUniformControllers.forEach(function (controller) {
      try { controller.abort(); } catch (_err) {}
    });
    priceUniformControllers.clear();
    priceUniformChecks.clear();
  }

  // Uniform-price detection must never fetch and DOM-parse another full 50-card collection
  // section. The alternate view returns only a tiny JSON payload (first price after Shopify's
  // price-ascending sort, product count, and the unfiltered Shopify range maximum).
  // A hard response-size ceiling also makes a missing/misconfigured alternate view fail open
  // instead of accidentally reading an entire storefront page into memory.
  function fetchPriceAuditText(target) {
    var controller = window.AbortController ? new AbortController() : null;
    if (controller) priceUniformControllers.add(controller);
    var timeoutId = window.setTimeout(function () {
      if (controller) {
        try { controller.abort(); } catch (_err) {}
      }
    }, 6000);

    return fetch(target.toString(), {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json, text/plain;q=0.9',
        'X-Requested-With': 'XMLHttpRequest'
      },
      signal: controller ? controller.signal : undefined
    }).then(function (response) {
      if (!response.ok) throw new Error('Price audit request failed: ' + response.status);

      var declaredLength = Math.round(Number(response.headers.get('content-length') || 0));
      if (declaredLength > 16384) throw new Error('Price audit response exceeded the safe size limit');

      if (!response.body || !response.body.getReader || !window.TextDecoder) {
        return response.text().then(function (text) {
          if (text.length > 16384) throw new Error('Price audit response exceeded the safe size limit');
          return text;
        });
      }

      var reader = response.body.getReader();
      var decoder = new TextDecoder();
      var total = 0;
      var output = '';

      function readChunk() {
        return reader.read().then(function (result) {
          if (result.done) {
            output += decoder.decode();
            return output;
          }
          total += result.value ? result.value.byteLength : 0;
          if (total > 16384) {
            try { reader.cancel(); } catch (_err) {}
            throw new Error('Price audit response exceeded the safe size limit');
          }
          output += decoder.decode(result.value, { stream: true });
          return readChunk();
        });
      }
      return readChunk();
    }).finally(function () {
      window.clearTimeout(timeoutId);
      if (controller) priceUniformControllers.delete(controller);
    });
  }

  function fetchPriceFilterGroup(collectionRoot) {
    var liveUrl = new URL(window.location.href);
    liveUrl.searchParams.delete('page');
    liveUrl.searchParams.set('view', 'es-price-filter');

    return fetchPriceAuditText(liveUrl).then(function (text) {
      var template = document.createElement('template');
      template.innerHTML = String(text || '').trim();
      var group = template.content.querySelector('[data-es-filter-kind="price"]');
      if (!group) throw new Error('Price filter view did not return a Price group');

      collectionRoot.querySelectorAll('[data-es-native-filter-form] .es-native-filter__groups').forEach(function (groups) {
        if (groups.querySelector('[data-es-filter-kind="price"]')) return;
        groups.appendChild(group.cloneNode(true));
      });
      reorderFilterGroups();
      restoreGroupStates();
      bindGroupStateListeners();
      initPriceRanges(collectionRoot);
      updateDesktopSidebarHeight();
      return true;
    });
  }

  function ensurePriceFilterGroups(collectionRoot) {
    if (!collectionRoot) return Promise.resolve(false);
    if (collectionRoot.querySelector('[data-es-filter-kind="price"]')) return Promise.resolve(true);
    if (collectionRoot.__esPriceGroupPromise) return collectionRoot.__esPriceGroupPromise;

    collectionRoot.__esPriceGroupPromise = fetchPriceFilterGroup(collectionRoot).catch(function () {
      return false;
    }).finally(function () {
      collectionRoot.__esPriceGroupPromise = null;
    });
    return collectionRoot.__esPriceGroupPromise;
  }

  // Shopify's price filter exposes the true maximum but not a dependable collection
  // minimum. The tiny alternate view is sorted price-low-to-high. If its first product is
  // single-priced and equals the unfiltered range maximum, every product is uniform.
  function auditCollectionUniformPrice(collectionRoot, collectionUrl) {
    var expectedMax = getCollectionRangeMax(collectionRoot);
    var expectedCount = getCollectionProductCount(collectionRoot);
    if (!Number.isFinite(expectedMax) || expectedMax < 0) return Promise.resolve(false);

    var target = new URL(collectionUrl, window.location.origin);
    target.search = '';
    target.searchParams.set('sort_by', 'price-ascending');
    target.searchParams.set('view', 'es-price-audit');

    return fetchPriceAuditText(target).then(function (text) {
      var snapshot = parsePriceAuditPayload(text);
      if (!snapshot) return false;
      if (expectedCount && snapshot.count && expectedCount !== snapshot.count) return false;
      if (snapshot.rangeMax !== expectedMax) return false;
      return snapshot.min === snapshot.max && snapshot.min === snapshot.rangeMax;
    });
  }

  function initUniformPriceFilter() {
    var collectionRoot = document.querySelector('.collection-page-fullwidth');
    if (!collectionRoot) return;
    var collectionUrl = collectionRoot.dataset.esCollectionUrl || '';
    if (!collectionUrl) return;

    var serverConfirmed = collectionRoot.dataset.esPriceUniformServer === 'true';
    var serverCandidate = collectionRoot.dataset.esPriceUniformCandidate === 'true';
    var hasPriceGroup = !!collectionRoot.querySelector('[data-es-filter-kind="price"]');

    if (serverConfirmed) {
      var serverKey = getPriceUniformKey(collectionRoot, collectionUrl);
      setCachedPriceUniform(serverKey, true);
      setUniformPriceVisibility(collectionRoot, true);
      return;
    }

    if (!hasPriceGroup && !serverCandidate) return;

    var key = getPriceUniformKey(collectionRoot, collectionUrl);
    if (!serverCandidate && !currentPageCouldBeUniform(collectionRoot)) {
      setCachedPriceUniform(key, false);
      setUniformPriceVisibility(collectionRoot, false);
      return;
    }

    var cached = getCachedPriceUniform(key);
    if (cached !== null) {
      if (cached) {
        setUniformPriceVisibility(collectionRoot, true);
      } else {
        ensurePriceFilterGroups(collectionRoot).then(function () {
          setUniformPriceVisibility(collectionRoot, false);
        });
      }
      return;
    }

    // A server-side candidate omits the Price markup entirely. A legacy/non-candidate
    // page can still hide its rendered group while the same tiny audit is pending.
    if (hasPriceGroup) setPriceAuditPending(collectionRoot, !hasActivePriceParameters());

    var check = priceUniformChecks.get(key);
    if (!check) {
      check = auditCollectionUniformPrice(collectionRoot, collectionUrl).then(function (uniform) {
        setCachedPriceUniform(key, uniform);
        return uniform;
      }).catch(function (error) {
        if (error && error.name === 'AbortError') return null;
        return false;
      }).finally(function () {
        if (priceUniformChecks.get(key) === check) priceUniformChecks.delete(key);
      });
      priceUniformChecks.set(key, check);
    }

    check.then(function (uniform) {
      if (uniform === null) return;
      var liveRoot = document.querySelector('.collection-page-fullwidth');
      if (!liveRoot) return;
      var liveUrl = liveRoot.dataset.esCollectionUrl || '';
      if (!liveUrl || getPriceUniformKey(liveRoot, liveUrl) !== key) return;

      if (uniform) {
        setUniformPriceVisibility(liveRoot, true);
        return;
      }
      ensurePriceFilterGroups(liveRoot).then(function () {
        var currentRoot = document.querySelector('.collection-page-fullwidth');
        if (currentRoot !== liveRoot) return;
        setUniformPriceVisibility(liveRoot, false);
      });
    });
  }

  function reorderFilterGroups() {
    document.querySelectorAll('[data-es-native-filter-form]').forEach(function (form) {
      if (form.dataset.esFilterContext !== 'sunglasses') return;
      var groups = form.querySelector('.es-native-filter__groups');
      if (!groups) return;
      ['shape', 'polarization', 'size', 'color', 'material', 'price'].forEach(function (kind) {
        groups.querySelectorAll('[data-es-filter-kind="' + kind + '"]').forEach(function (group) {
          groups.appendChild(group);
        });
      });
    });
  }

  function filterGroupStateKey(form, group) {
    if (!form || !group) return '';
    return [
      form.dataset.esFilterContext || 'eyeglasses',
      form.dataset.esFilterInstance || 'filters',
      group.dataset.esFilterKind || ''
    ].join('\u001f');
  }

  function captureFilterGroupStates(root) {
    var states = {};
    if (!root || !root.querySelectorAll) return states;
    root.querySelectorAll('[data-es-native-filter-form]').forEach(function (form) {
      form.querySelectorAll('.es-native-filter__group').forEach(function (group) {
        var key = filterGroupStateKey(form, group);
        if (key) states[key] = !!group.open;
      });
    });
    return states;
  }

  function applyFilterGroupStates(root, states) {
    if (!root || !root.querySelectorAll || !states) return;
    root.querySelectorAll('[data-es-native-filter-form]').forEach(function (form) {
      form.querySelectorAll('.es-native-filter__group').forEach(function (group) {
        var key = filterGroupStateKey(form, group);
        if (!key || !Object.prototype.hasOwnProperty.call(states, key)) return;
        group.open = !!states[key];
        group.dataset.esOpenStateHydrated = '1';
      });
    });
  }

  function restoreGroupStates() {
    var desktop = isDesktop();
    document.querySelectorAll('[data-es-native-filter-form]').forEach(function (form) {
      var context = form.dataset.esFilterContext || 'eyeglasses';
      var states = readGroupStates(context);
      form.querySelectorAll('.es-native-filter__group').forEach(function (group) {
        var kind = group.dataset.esFilterKind || '';
        var hasSaved = Object.prototype.hasOwnProperty.call(states, kind);

        // AJAX replacements receive their final open state while still detached. Do not
        // toggle them again after insertion, otherwise untouched chevrons visibly rotate.
        if (group.dataset.esOpenStateHydrated === '1') return;

        if (!desktop) {
          group.open = group.classList.contains('is-active');
        } else if (hasSaved) {
          // An explicit customer choice must win over the "active groups open" default.
          group.open = !!states[kind];
        } else if (group.classList.contains('is-active')) {
          group.open = true;
        } else {
          group.open = group.dataset.esDefaultOpen === 'true';
        }
      });
    });
  }

  function bindGroupStateListeners() {
    document.querySelectorAll('.es-native-filter__group').forEach(function (group) {
      if (group.dataset.esStateReady === '1') return;
      group.dataset.esStateReady = '1';
      group.addEventListener('toggle', function () {
        if (!group.open) {
          group.querySelectorAll('[data-es-frame-width-help-panel]:not([hidden])').forEach(function (panel) {
            closeFrameWidthHelp(panel, false);
          });
        }
        if (syncingGroupState || !isDesktop()) return;
        var form = group.closest('[data-es-native-filter-form]');
        var context = form && form.dataset.esFilterContext ? form.dataset.esFilterContext : 'eyeglasses';
        var kind = group.dataset.esFilterKind || '';
        writeGroupState(context, kind, group.open);

        syncingGroupState = true;
        document.querySelectorAll('[data-es-native-filter-form][data-es-filter-context="' + context + '"] [data-es-filter-kind="' + kind + '"]').forEach(function (peer) {
          if (peer !== group) peer.open = group.open;
        });
        syncingGroupState = false;
      });
    });
  }

  function isUsableFocusTarget(element) {
    if (!element || !element.isConnected || !element.focus) return false;
    if (element.disabled || element.hidden || element.getAttribute('aria-hidden') === 'true') return false;
    if (element.closest && element.closest('[inert], [aria-hidden="true"], [hidden]')) return false;
    if (!window.getComputedStyle) return true;
    var style = window.getComputedStyle(element);
    if (!style || style.display === 'none' || style.visibility === 'hidden') return false;
    var rect = element.getBoundingClientRect ? element.getBoundingClientRect() : null;
    return !rect || (rect.width > 0 && rect.height > 0);
  }

  function firstUsableTarget(nodes) {
    var target = null;
    Array.prototype.forEach.call(nodes || [], function (candidate) {
      if (!target && isUsableFocusTarget(candidate)) target = candidate;
    });
    return target;
  }

  function activeFilterFocusState(active) {
    var chip = active && active.closest ? active.closest('.es-active-filter, .es-active-filters__clear') : null;
    if (!chip) return null;
    var row = chip.closest('.es-active-filters');
    var items = row ? Array.prototype.slice.call(row.querySelectorAll('.es-active-filter, .es-active-filters__clear')) : [];
    return {
      type: 'active-filter',
      index: Math.max(0, items.indexOf(chip)),
      param: chip.getAttribute('data-es-filter-param') || '',
      value: chip.getAttribute('data-es-filter-value') || '',
      clear: chip.hasAttribute('data-es-active-filter-clear')
    };
  }

  function visibleActiveFiltersRow() {
    var rows = document.querySelectorAll('.es-active-filters');
    var visible = null;
    Array.prototype.forEach.call(rows || [], function (row) {
      if (visible || !row || !row.getBoundingClientRect) return;
      var style = window.getComputedStyle ? window.getComputedStyle(row) : null;
      var rect = row.getBoundingClientRect();
      if ((!style || (style.display !== 'none' && style.visibility !== 'hidden')) && rect.width > 0 && rect.height > 0) {
        visible = row;
      }
    });
    return visible;
  }

  function updateMobileActiveFilterOverflow(row) {
    if (!row || !row.isConnected) return;
    var shell = row.closest('.es-collection-mobile-active');
    if (!shell) return;

    var maxScroll = Math.max(0, row.scrollWidth - row.clientWidth);
    var currentScroll = Math.max(0, row.scrollLeft);
    var tolerance = 2;

    shell.classList.toggle('es-active-scroll-before', maxScroll > tolerance && currentScroll > tolerance);
    shell.classList.toggle('es-active-scroll-after', maxScroll > tolerance && currentScroll < maxScroll - tolerance);
  }

  function updateAllMobileActiveFilterOverflow() {
    document.querySelectorAll('.es-collection-mobile-active .es-active-filters').forEach(updateMobileActiveFilterOverflow);
  }

  function initMobileActiveFilterOverflow(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('.es-collection-mobile-active .es-active-filters').forEach(function (row) {
      if (row.getAttribute('data-es-overflow-hint-bound') !== 'true') {
        row.setAttribute('data-es-overflow-hint-bound', 'true');
        row.addEventListener('scroll', function () {
          updateMobileActiveFilterOverflow(row);
        }, { passive: true });
      }
      updateMobileActiveFilterOverflow(row);
    });

    window.requestAnimationFrame(updateAllMobileActiveFilterOverflow);
  }

  function captureUiState() {
    var sidebar = document.querySelector('.es-native-filter-desktop');
    var activeFilters = visibleActiveFiltersRow();
    var active = document.activeElement;
    var focus = null;
    var keyboardFocus = lastInputModality === 'keyboard';

    try {
      if (active && active.matches && active.matches(':focus-visible')) keyboardFocus = true;
    } catch (e) {}

    if (keyboardFocus && active && active !== document.body && active.matches) {
      var activeChip = activeFilterFocusState(active);
      if (activeChip) {
        focus = activeChip;
      } else {
        var form = active.closest('[data-es-native-filter-form]');
        var instance = form ? (form.getAttribute('data-es-filter-instance') || '') : '';
        var inMobileDrawer = !!active.closest('.filter-to-left');
        var checkbox = active.closest('.es-native-filter__checkbox');
        var range = active.closest('[data-es-price-min], [data-es-price-max]');

        if (inMobileDrawer) {
          focus = { type: 'mobile-filter-return' };
        } else if (checkbox) {
          focus = {
            type: 'filter-option',
            instance: instance,
            name: checkbox.getAttribute('name') || '',
            value: checkbox.getAttribute('value') || ''
          };
        } else if (range) {
          focus = {
            type: 'price-control',
            instance: instance,
            name: range.getAttribute('name') || '',
            side: range.hasAttribute('data-es-price-min') ? 'min' : 'max'
          };
        } else if (active.matches('input[name], select[name], button, a[href]')) {
          focus = {
            type: 'generic',
            instance: instance,
            tag: active.tagName,
            name: active.getAttribute('name') || '',
            value: active.getAttribute('value') || '',
            href: active.getAttribute('href') || '',
            id: active.id || ''
          };
        }
      }
    }

    return {
      sidebarScroll: sidebar ? sidebar.scrollTop : 0,
      activeFiltersScroll: activeFilters ? activeFilters.scrollLeft : 0,
      groupStates: captureFilterGroupStates(document.querySelector('.collection-page-fullwidth')),
      focus: focus
    };
  }

  function focusWithoutScroll(target) {
    if (!isUsableFocusTarget(target)) return false;
    try { target.focus({ preventScroll: true }); }
    catch (e) { try { target.focus(); } catch (e2) { return false; } }
    return document.activeElement === target;
  }

  function filterInstanceRoot(instance) {
    if (!instance) return null;
    return document.querySelector('[data-es-native-filter-form][data-es-filter-instance="' + cssEscape(instance) + '"]');
  }

  function restoreActiveFilterFocus(focus) {
    var row = visibleActiveFiltersRow();
    if (row) {
      var exact = null;
      if (focus.clear) {
        exact = row.querySelector('[data-es-active-filter-clear]');
      } else if (focus.param) {
        var exactSelector = '.es-active-filter[data-es-filter-param="' + cssEscape(focus.param) + '"]';
        if (focus.value) exactSelector += '[data-es-filter-value="' + cssEscape(focus.value) + '"]';
        exact = row.querySelector(exactSelector);
      }
      if (focusWithoutScroll(exact)) return;

      var items = Array.prototype.slice.call(row.querySelectorAll('.es-active-filter, .es-active-filters__clear')).filter(isUsableFocusTarget);
      if (items.length) {
        var index = Math.min(Math.max(0, Number(focus.index) || 0), items.length - 1);
        if (focusWithoutScroll(items[index])) return;
      }
    }

    var fallback = firstUsableTarget(document.querySelectorAll('[data-es-hide-filters], [data-es-show-filters], .js_filter'));
    focusWithoutScroll(fallback);
  }

  function restoreCollectionScrollState(state) {
    if (!state) return;
    var sidebar = document.querySelector('.es-native-filter-desktop');
    if (sidebar) sidebar.scrollTop = state.sidebarScroll || 0;
    var activeFilters = visibleActiveFiltersRow();
    if (activeFilters) {
      activeFilters.scrollLeft = state.activeFiltersScroll || 0;
      updateMobileActiveFilterOverflow(activeFilters);
      window.requestAnimationFrame(function () {
        updateMobileActiveFilterOverflow(activeFilters);
      });
    }
  }

  function restoreUiState(state) {
    if (!state) return;
    restoreCollectionScrollState(state);

    var focus = state.focus;
    if (!focus) return;
    var target = null;

    if (focus.type === 'mobile-filter-return') {
      target = firstUsableTarget(document.querySelectorAll('.js_filter'));
    } else if (focus.type === 'filter-option') {
      var form = filterInstanceRoot(focus.instance);
      var selector = '.es-native-filter__checkbox[name="' + cssEscape(focus.name) + '"]';
      if (focus.value) selector += '[value="' + cssEscape(focus.value) + '"]';
      target = firstUsableTarget((form || document).querySelectorAll(selector));
      if (!target && form) target = firstUsableTarget(document.querySelectorAll(selector));
    } else if (focus.type === 'price-control') {
      var priceForm = filterInstanceRoot(focus.instance);
      var priceSelector = focus.side === 'min' ? '[data-es-price-min]' : '[data-es-price-max]';
      if (focus.name) priceSelector += '[name="' + cssEscape(focus.name) + '"]';
      target = firstUsableTarget((priceForm || document).querySelectorAll(priceSelector));
      if (!target && priceForm) target = firstUsableTarget(document.querySelectorAll(priceSelector));
    } else if (focus.type === 'active-filter') {
      restoreActiveFilterFocus(focus);
      return;
    } else if (focus.type === 'generic') {
      var scope = filterInstanceRoot(focus.instance) || document;
      var genericSelector = '';
      if (focus.id) genericSelector = '#' + cssEscape(focus.id);
      else if (focus.name) {
        genericSelector = focus.tag.toLowerCase() + '[name="' + cssEscape(focus.name) + '"]';
        if (focus.value) genericSelector += '[value="' + cssEscape(focus.value) + '"]';
      } else if (focus.href) {
        genericSelector = 'a[href="' + cssEscape(focus.href) + '"]';
      }
      if (genericSelector) target = firstUsableTarget(scope.querySelectorAll(genericSelector));
    }

    focusWithoutScroll(target);
  }

  function cssEscape(value) {
    if (window.CSS && window.CSS.escape) return window.CSS.escape(String(value));
    return String(value).replace(/(["\\])/g, '\\$1');
  }

  function buildFormUrl(form) {
    var target = new URL(form.getAttribute('action') || window.location.pathname, window.location.origin);
    var params = new URLSearchParams();
    new FormData(form).forEach(function (value, key) {
      value = String(value == null ? '' : value).trim();
      if (value !== '') params.append(key, value);
    });
    params.delete('page');
    target.search = params.toString();
    return target;
  }

  function setLoading(loading) {
    window.clearTimeout(loadingVisualTimer);
    loadingVisualTimer = null;

    var root = document.querySelector('.collection-page-fullwidth');
    if (!root) return;

    var status = root.querySelector('.es-native-ajax-status');
    root.setAttribute('aria-busy', loading ? 'true' : 'false');
    root.classList.toggle('es-native-ajax-pending', !!loading);

    if (!loading) {
      root.classList.remove('es-native-ajax-loading');
      if (status) status.setAttribute('aria-hidden', 'true');
      return;
    }

    // Keep fast responses visually quiet. Only reveal the loading treatment when the
    // request lasts long enough for feedback to be useful instead of flashing.
    root.classList.remove('es-native-ajax-loading');
    if (status) status.setAttribute('aria-hidden', 'true');
    loadingVisualTimer = window.setTimeout(function () {
      if (!root.isConnected || root.getAttribute('aria-busy') !== 'true') return;
      root.classList.add('es-native-ajax-loading');
      if (status) status.setAttribute('aria-hidden', 'false');
    }, LOADING_VISUAL_DELAY);
  }

  function ensureMobileFilterContent(drawer) {
    if (!drawer || !drawer.querySelector) return null;
    var existing = drawer.querySelector('[data-es-native-filter-form]');
    if (existing) return existing;

    var source = drawer.querySelector('[data-es-mobile-filter-template]');
    var sidebar = drawer.querySelector('.filter_sidebar');
    if (!source || !sidebar) return null;

    var markup = String(source.textContent || source.innerHTML || '').trim();
    if (!markup) return null;

    try {
      if (String(source.getAttribute('type') || '').toLowerCase() === 'application/json') {
        var payload = JSON.parse(markup);
        markup = payload && typeof payload.html === 'string' ? payload.html.trim() : '';
      }
      if (!markup) return null;
      var parser = document.createElement('template');
      parser.innerHTML = markup;
      var fragment = parser.content.cloneNode(true);
      var form = fragment.querySelector('[data-es-native-filter-form]');
      if (!form) return null;
      sidebar.insertBefore(fragment, source);
      source.remove();

      reorderFilterGroups();
      restoreGroupStates();
      bindGroupStateListeners();
      initPriceRanges(drawer);
      initUniformPriceFilter();
      return form;
    } catch (error) {
      if (window.ESDebug) window.ESDebug('collection.mobile-filter.materialize', error);
      return null;
    }
  }

  // EYESHELLS v1381 — this file is the single owner of the mobile drawer, outside gutter,
  // accessibility state, page scroll lock, and global overlay across AJAX replacements.
  function syncMobileFilterDrawerState() {
    var drawer = document.querySelector('.filter-to-left');
    var open = !!(drawer && drawer.classList.contains('active') && !isDesktop());

    if (drawer) {
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (open) drawer.removeAttribute('inert');
      else drawer.setAttribute('inert', '');
    }
    document.querySelectorAll('.js_filter').forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.documentElement.classList.toggle('es-mobile-filters-open', open);

    document.querySelectorAll('.overlay-filter').forEach(function (overlay) {
      overlay.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (!open) overlay.classList.remove('active');
    });
  }

  function observeMobileFilterDrawer() {
    if (mobileDrawerObserver) {
      try { mobileDrawerObserver.disconnect(); } catch (e) {}
      mobileDrawerObserver = null;
    }

    var drawer = document.querySelector('.filter-to-left');
    if (drawer && window.MutationObserver) {
      mobileDrawerObserver = new MutationObserver(function () {
        syncMobileFilterDrawerState();
      });
      mobileDrawerObserver.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
    syncMobileFilterDrawerState();
  }

  function openMobileFilterOverlay(trigger) {
    if (isDesktop()) return;
    var drawer = document.querySelector('.filter-to-left');
    if (!drawer) return;
    if (!ensureMobileFilterContent(drawer)) return;

    drawer.classList.add('active');
    drawer.setAttribute('aria-hidden', 'false');
    if (trigger && trigger.setAttribute) trigger.setAttribute('aria-expanded', 'true');
    drawer.removeAttribute('inert');
    document.querySelectorAll('.overlay-filter').forEach(function (overlay) {
      overlay.classList.add('active');
      overlay.setAttribute('aria-hidden', 'false');
    });
    document.documentElement.classList.add('es-mobile-filters-open');
    syncMobileFilterDrawerState();

    // Move focus into the drawer without shifting the page underneath it.
    window.requestAnimationFrame(function () {
      var close = drawer.querySelector('.close_filter');
      if (!close || !close.focus) return;
      try { close.focus({ preventScroll: true }); }
      catch (e) { try { close.focus(); } catch (e2) {} }
    });
  }

  function closeMobileFilterOverlay(returnFocus) {
    closeAllFrameWidthHelp(null, false);
    var active = document.activeElement;
    if (active && active.closest && active.closest('.filter-to-left')) {
      try { active.blur(); } catch (e) {}
    }

    document.querySelectorAll('.filter-to-left.active').forEach(function (drawer) {
      drawer.classList.remove('active');
      drawer.setAttribute('aria-hidden', 'true');
      drawer.setAttribute('inert', '');
    });
    document.querySelectorAll('.overlay-filter.active').forEach(function (overlay) {
      overlay.classList.remove('active');
      overlay.setAttribute('aria-hidden', 'true');
    });
    document.documentElement.classList.remove('es-mobile-filters-open');
    document.querySelectorAll('.js_filter').forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    });

    // A second overlay-only cleanup after the slide-out transition protects against
    // late legacy handlers without closing a drawer the customer has deliberately reopened.
    window.setTimeout(function () {
      if (document.querySelector('.filter-to-left.active')) {
        syncMobileFilterDrawerState();
        return;
      }
      document.querySelectorAll('.overlay-filter.active').forEach(function (overlay) {
        overlay.classList.remove('active');
        overlay.setAttribute('aria-hidden', 'true');
      });
      document.documentElement.classList.remove('es-mobile-filters-open');
    }, 380);

    if (returnFocus && returnFocus.focus) {
      window.requestAnimationFrame(function () {
        try { returnFocus.focus({ preventScroll: true }); }
        catch (e) { try { returnFocus.focus(); } catch (e2) {} }
      });
    }
  }

  function requestIdleTask(callback, timeout) {
    if (window.ES && window.ES.scheduler && typeof window.ES.scheduler.idle === 'function') {
      return { type: 'runtime', cancel: window.ES.scheduler.idle(callback, timeout || 700) };
    }
    if (window.requestIdleCallback) {
      return { type: 'idle', id: window.requestIdleCallback(callback, { timeout: timeout || 700 }) };
    }
    return { type: 'timeout', id: window.setTimeout(callback, 120) };
  }

  function cancelIdleTask(task) {
    if (!task) return;
    if (task.type === 'runtime' && typeof task.cancel === 'function') task.cancel();
    else if (task.type === 'idle' && window.cancelIdleCallback) window.cancelIdleCallback(task.id);
    else window.clearTimeout(task.id);
  }

  function cancelScheduledEnhancements() {
    if (enhancementObserver) {
      try { enhancementObserver.disconnect(); } catch (e) {}
      enhancementObserver = null;
    }
    cancelIdleTask(enhancementIdleHandle);
    enhancementIdleHandle = null;
  }

  function primeCardEnhancements(card) {
    if (!card || card.dataset.esEnhancementsReady === '1') return;
    card.dataset.esEnhancementsReady = '1';
    try {
      if (typeof window.__esPrimeSelectedSwatchCache === 'function') {
        window.__esPrimeSelectedSwatchCache(card);
      }
    } catch (e) {}
  }

  function schedulePostRefreshEnhancements(root) {
    cancelScheduledEnhancements();
    var products = root && root.querySelector ? root.querySelector('.es-native-products-column') : null;
    if (!products) return;

    var cards = products.querySelectorAll('.es-collection-grid-item, .list_prod');
    if (cards.length && window.ES && window.ES.observe && typeof window.ES.observe.intersection === 'function') {
      var cleanups = [];
      cards.forEach(function (card) {
        var cleanup = window.ES.observe.intersection(card, function (entry) {
          if (!entry.isIntersecting) return;
          primeCardEnhancements(entry.target);
          cleanup();
        }, { rootMargin: '650px 0px' });
        cleanups.push(cleanup);
      });
      enhancementObserver = { disconnect: function () { cleanups.splice(0).forEach(function (cleanup) { try { cleanup(); } catch (_cleanupError) {} }); } };
    } else if (window.IntersectionObserver && cards.length) {
      enhancementObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          primeCardEnhancements(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '650px 0px' });
      cards.forEach(function (card) { enhancementObserver.observe(card); });
    }

    enhancementIdleHandle = requestIdleTask(function () {
      enhancementIdleHandle = null;
      if (!window.IntersectionObserver && !(window.ES && window.ES.observe && window.ES.observe.intersection)) cards.forEach(primeCardEnhancements);
      try {
        if (typeof window.__esInitSwatchScrollHints === 'function') {
          window.__esInitSwatchScrollHints(products);
        }
      } catch (e) {}
      try {
        if (typeof window.ES_quickViewAllowed === 'function' &&
            window.ES_quickViewAllowed() &&
            typeof window.quickView === 'function') {
          window.quickView();
        }
      } catch (e) {}
    }, 700);
  }

  function runImmediatePostRefreshHooks(root) {
    try { if (window.ES_applyCollectionCols) window.ES_applyCollectionCols(); } catch (e) {}
    try {
      document.dispatchEvent(new CustomEvent('es:collection:updated', {
        detail: { url: window.location.href, root: root || null }
      }));
    } catch (e) {}
  }

  function getCollectionSectionId(root) {
    if (!root) return '';
    var id = root.getAttribute('data-es-section-id') || '';
    if (id) return id;
    var wrapper = root.closest ? root.closest('.shopify-section[id^="shopify-section-"]') : null;
    if (!wrapper) return '';
    return String(wrapper.id || '').replace(/^shopify-section-/, '');
  }

  function readCollectionCache(key) {
    var item = collectionCache.get(key);
    if (!item) return null;
    if ((Date.now() - item.time) > COLLECTION_CACHE_TTL) {
      collectionCache.delete(key);
      return null;
    }
    return item;
  }

  function writeCollectionCache(key, html, partial) {
    collectionCache.delete(key);
    collectionCache.set(key, { html: html, partial: !!partial, time: Date.now() });
    while (collectionCache.size > COLLECTION_CACHE_LIMIT) {
      collectionCache.delete(collectionCache.keys().next().value);
    }
  }

  function parseCollectionMarkup(html, partial) {
    var parsed;
    var nextRoot;
    var title = '';

    if (partial) {
      var template = document.createElement('template');
      template.innerHTML = String(html || '').trim();
      nextRoot = template.content.querySelector('.collection-page-fullwidth');
    } else {
      parsed = new DOMParser().parseFromString(html, 'text/html');
      nextRoot = parsed.querySelector('.collection-page-fullwidth');
      title = parsed.title || '';
    }

    return { root: nextRoot, title: title };
  }

  function fetchText(requestUrl, signal) {
    return fetch(requestUrl.toString(), {
      method: 'GET',
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      signal: signal
    }).then(function (response) {
      if (!response.ok) {
        var error = new Error('Collection request failed: ' + response.status);
        error.status = response.status;
        throw error;
      }
      return response.text();
    });
  }

  function fetchCollectionPayload(targetUrl, currentRoot, signal) {
    var sectionId = getCollectionSectionId(currentRoot);
    var cacheKey = targetUrl.toString() + '::' + (sectionId || 'full');
    var cached = readCollectionCache(cacheKey);
    if (cached) {
      var cachedPayload = parseCollectionMarkup(cached.html, cached.partial);
      if (cachedPayload.root) return Promise.resolve(cachedPayload);
      collectionCache.delete(cacheKey);
    }

    function fetchFullPage() {
      return fetchText(targetUrl, signal).then(function (html) {
        var payload = parseCollectionMarkup(html, false);
        if (!payload.root) throw new Error('Collection content was not found in the response.');
        writeCollectionCache(cacheKey, html, false);
        return payload;
      });
    }

    if (!sectionId || partialRenderingDisabled) return fetchFullPage();

    var sectionUrl = new URL(targetUrl.toString());
    sectionUrl.searchParams.set('section_id', sectionId);
    return fetchText(sectionUrl, signal).then(function (html) {
      var payload = parseCollectionMarkup(html, true);
      if (!payload.root) {
        var error = new Error('The collection section response did not contain the collection root.');
        error.esPartialUnsupported = true;
        throw error;
      }
      writeCollectionCache(cacheKey, html, true);
      return payload;
    }).catch(function (error) {
      if (error && error.name === 'AbortError') throw error;
      if (error && (error.esPartialUnsupported || error.status === 400 || error.status === 404)) {
        partialRenderingDisabled = true;
      }
      return fetchFullPage();
    });
  }

  function visibleResultsAnchor(selector) {
    var match = null;
    document.querySelectorAll(selector).forEach(function (candidate) {
      if (match || !candidate.getBoundingClientRect) return;
      var style = window.getComputedStyle ? window.getComputedStyle(candidate) : null;
      var rect = candidate.getBoundingClientRect();
      if ((!style || (style.display !== 'none' && style.visibility !== 'hidden')) && rect.width > 0 && rect.height > 0) {
        match = candidate;
      }
    });
    return match;
  }

  function getResultsStartAnchor() {
    var preferred = isDesktop() ? '[data-es-results-anchor="desktop"]' : '[data-es-results-anchor="mobile"]';
    return visibleResultsAnchor(preferred) ||
      visibleResultsAnchor('[data-es-results-anchor]') ||
      visibleResultsAnchor('.es-native-products-column');
  }

  function getResultsViewportOffset() {
    var selectors = isDesktop()
      ? ['[data-es-layout-header="desktop"]', '#header.header-v1-h1']
      : ['[data-es-layout-header="mobile"]', '.menu_moblie'];
    var bottom = 0;

    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (header) {
        if (!header.getBoundingClientRect) return;
        var style = window.getComputedStyle ? window.getComputedStyle(header) : null;
        if (style && (style.display === 'none' || style.visibility === 'hidden')) return;
        if (style && style.position !== 'fixed' && style.position !== 'sticky') return;
        var rect = header.getBoundingClientRect();
        if (rect.width <= 0 || rect.height <= 0 || rect.bottom <= 0 || rect.top >= window.innerHeight) return;
        bottom = Math.max(bottom, rect.bottom);
      });
    });

    return Math.max(0, Math.ceil(bottom));
  }

  function positionCollectionResults(state) {
    var anchor = getResultsStartAnchor();
    if (!anchor) return;
    var top = Math.max(0, Math.round(anchor.getBoundingClientRect().top + window.pageYOffset - getResultsViewportOffset()));
    var rootStyle = document.documentElement.style;
    var previousBehavior = rootStyle.scrollBehavior;
    rootStyle.scrollBehavior = 'auto';
    window.scrollTo(0, top);
    rootStyle.scrollBehavior = previousBehavior;
    restoreCollectionScrollState(state);
    updateDesktopSidebarHeight();
  }

  function cancelResultsPositioning() {
    if (resultsPositionFrame) window.cancelAnimationFrame(resultsPositionFrame);
    if (resultsPositionSettleFrame) window.cancelAnimationFrame(resultsPositionSettleFrame);
    resultsPositionFrame = null;
    resultsPositionSettleFrame = null;
  }

  function scrollCollectionResultsToStart(state) {
    cancelResultsPositioning();

    // Position immediately after the AJAX replacement, then confirm it across two
    // animation frames so sticky headers and the newly rendered toolbar have settled.
    positionCollectionResults(state);
    resultsPositionFrame = window.requestAnimationFrame(function () {
      resultsPositionFrame = null;
      positionCollectionResults(state);
      resultsPositionSettleFrame = window.requestAnimationFrame(function () {
        resultsPositionSettleFrame = null;
        positionCollectionResults(state);
      });
    });
  }

  function recoverInvalidCollectionPage(root) {
    if (!root || root.getAttribute('data-es-invalid-collection-page') !== 'true') return false;
    try {
      var target = new URL(window.location.href);
      target.searchParams.delete('page');
      window.location.replace(target.toString());
    } catch (error) {
      if (window.ESDebug) window.ESDebug('collection.invalid-page-recovery', error);
      var fallback = root.getAttribute('data-es-collection-url') || '/collections/all';
      window.location.replace(fallback);
    }
    return true;
  }

  function loadCollection(url, options) {
    options = options || {};
    cancelResultsPositioning();
    closeMobileFilterOverlay();
    cancelScheduledEnhancements();
    abortPriceUniformAudits();
    window.clearTimeout(collectionRequestFailSafe);
    collectionRequestFailSafe = null;
    var currentRoot = document.querySelector('.collection-page-fullwidth');
    if (!currentRoot) {
      window.location.href = url.toString();
      return;
    }

    var state = captureUiState();
    var id = ++requestId;
    if (activeController && activeController.abort) {
      try { activeController.abort(); } catch (e) {}
    }
    activeController = window.AbortController ? new AbortController() : null;
    setLoading(true);
    collectionRequestFailSafe = window.setTimeout(function () {
      if (id !== requestId) return;
      setLoading(false);
      if (activeController && activeController.abort) {
        try { activeController.abort(); } catch (e) {}
      }
      window.location.assign(url.toString());
    }, COLLECTION_REQUEST_TIMEOUT);

    fetchCollectionPayload(
      url,
      currentRoot,
      activeController ? activeController.signal : undefined
    ).then(function (payload) {
      if (id !== requestId) return;
      var nextRoot = payload.root;
      var liveRoot = document.querySelector('.collection-page-fullwidth');
      if (!nextRoot || !liveRoot) throw new Error('Collection content was not found in the response.');

      closeMobileFilterOverlay();
      applyFilterGroupStates(nextRoot, state.groupStates);
      liveRoot.replaceWith(nextRoot);
      if (payload.title) document.title = payload.title;
      if (recoverInvalidCollectionPage(nextRoot)) return;

      // Make the new products interactive immediately. Non-critical swatch measurements,
      // cache priming, and quick-view warming are deferred until the browser is idle.
      setLoading(false);
      initCollectionUi();
      closeMobileFilterOverlay();
      runImmediatePostRefreshHooks(nextRoot);
      restoreUiState(state);
      schedulePostRefreshEnhancements(nextRoot);
      if (options.scrollResults || options.scrollProducts) scrollCollectionResultsToStart(state);
    }).catch(function (error) {
      closeMobileFilterOverlay();
      if (error && error.name === 'AbortError') return;
      if (id !== requestId) return;
      if (window.ESDebug) window.ESDebug('collection.ajax', error);
      setLoading(false);
      window.location.href = url.toString();
    }).finally(function () {
      closeMobileFilterOverlay();
      if (id === requestId) {
        window.clearTimeout(collectionRequestFailSafe);
        collectionRequestFailSafe = null;
        activeController = null;
        setLoading(false);
      }
    });
  }

  function navigate(url, options) {
    window.clearTimeout(submitTimer);
    submitTimer = null;
    options = options || {};
    var target = url instanceof URL ? url : new URL(url, window.location.href);
    if (options.push !== false && target.toString() !== window.location.href) {
      try { history.pushState({ esCollectionAjax: true }, '', target.toString()); }
      catch (e) { window.location.href = target.toString(); return; }
    }
    loadCollection(target, options);
  }

  window.ES_collectionNavigate = function (url, options) {
    navigate(url, options || {});
  };

  function queueForm(form, delay) {
    window.clearTimeout(submitTimer);
    submitTimer = window.setTimeout(function () {
      navigate(buildFormUrl(form), { push: true, scrollResults: true });
    }, delay || 180);
  }

  function isPlainClick(event) {
    return event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
  }

  function closeFrameWidthHelp(panel, restoreFocus) {
    if (!panel) return;
    var wrapper = panel.closest('[data-es-frame-width-help]');
    var trigger = wrapper && wrapper.querySelector('[data-es-frame-width-help-trigger]');
    panel.hidden = true;
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (restoreFocus && trigger && trigger.isConnected && trigger.focus) {
      try { trigger.focus({ preventScroll: true }); }
      catch (e) { try { trigger.focus(); } catch (e2) {} }
    }
  }

  function closeAllFrameWidthHelp(exceptPanel, restoreFocus) {
    document.querySelectorAll('[data-es-frame-width-help-panel]:not([hidden])').forEach(function (panel) {
      if (panel !== exceptPanel) closeFrameWidthHelp(panel, !!restoreFocus);
    });
  }

  function toggleFrameWidthHelp(trigger) {
    if (!trigger) return;
    var wrapper = trigger.closest('[data-es-frame-width-help]');
    var panel = wrapper && wrapper.querySelector('[data-es-frame-width-help-panel]');
    if (!panel) return;
    var willOpen = panel.hidden;
    closeAllFrameWidthHelp(panel, false);
    panel.hidden = !willOpen;
    trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    if (willOpen && panel.focus) {
      window.requestAnimationFrame(function () {
        if (panel.hidden || !panel.isConnected) return;
        try { panel.focus({ preventScroll: true }); }
        catch (e) { try { panel.focus(); } catch (e2) {} }
      });
    }
  }

  function collectionClickCapture(event) {
    if (!isPlainClick(event)) return;

    var frameHelpTrigger = event.target.closest('[data-es-frame-width-help-trigger]');
    if (frameHelpTrigger) {
      event.preventDefault();
      event.stopImmediatePropagation();
      toggleFrameWidthHelp(frameHelpTrigger);
      return;
    }

    var frameHelpClose = event.target.closest('[data-es-frame-width-help-close]');
    if (frameHelpClose) {
      event.preventDefault();
      event.stopImmediatePropagation();
      closeFrameWidthHelp(frameHelpClose.closest('[data-es-frame-width-help-panel]'), true);
      return;
    }

    if (!event.target.closest('[data-es-frame-width-help]')) {
      closeAllFrameWidthHelp(null, false);
    }

    var clearPriceButton = event.target.closest('[data-es-price-clear-min], [data-es-price-clear-max]');
    if (clearPriceButton) {
      event.preventDefault();
      event.stopImmediatePropagation();
      var priceRoot = clearPriceButton.closest('[data-es-price-range]');
      clearPreservedPrice(priceRoot, clearPriceButton.hasAttribute('data-es-price-clear-min') ? 'min' : 'max');
      if (isDesktop()) {
        var priceForm = clearPriceButton.closest('[data-es-native-filter-form]');
        if (priceForm) queueForm(priceForm, 120);
      }
      return;
    }

    var openButton = event.target.closest('.js_filter');
    if (openButton) {
      event.preventDefault();
      event.stopImmediatePropagation();
      openMobileFilterOverlay(openButton);
      return;
    }

    var closeButton = event.target.closest('.close_filter');
    if (closeButton) {
      event.preventDefault();
      event.stopImmediatePropagation();
      closeMobileFilterOverlay(document.querySelector('.js_filter'));
      return;
    }

    var hideButton = event.target.closest('[data-es-hide-filters]');
    if (hideButton) {
      event.preventDefault();
      event.stopImmediatePropagation();
      setSidebarHidden(true, true);
      return;
    }

    var showButton = event.target.closest('[data-es-show-filters]');
    if (showButton) {
      event.preventDefault();
      event.stopImmediatePropagation();
      setSidebarHidden(false, true);
      return;
    }

    var paginationLink = event.target.closest('.es-pagination a[href]');
    if (paginationLink) {
      event.preventDefault();
      event.stopImmediatePropagation();
      navigate(new URL(paginationLink.href, window.location.href), { push: true, scrollResults: true });
      return;
    }

    var activeLink = event.target.closest('.es-active-filter[href], .es-active-filters__clear[href]');
    if (activeLink) {
      event.preventDefault();
      event.stopImmediatePropagation();
      navigate(new URL(activeLink.href, window.location.href), { push: true, scrollResults: true });
    }
  }

  function initCollectionUi() {
    reorderFilterGroups();
    restoreSidebarHidden();
    restoreGroupStates();
    bindGroupStateListeners();
    initUniformPriceFilter();
    initPriceRanges();
    initSidebarWheel();
    observeMobileFilterDrawer();
    initMobileActiveFilterOverflow(document);
    updateDesktopSidebarHeight();
  }

  document.addEventListener('pointerdown', function () {
    lastInputModality = 'pointer';
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.metaKey || event.ctrlKey || event.altKey) return;
    lastInputModality = 'keyboard';
  }, true);

  document.addEventListener('input', function (event) {
    var rangeInput = event.target.closest('[data-es-price-min], [data-es-price-max]');
    if (!rangeInput) return;
    updatePriceRange(rangeInput.closest('[data-es-price-range]'), rangeInput);
  });

  document.addEventListener('change', function (event) {
    var checkbox = event.target.closest('.es-native-filter__checkbox');
    if (checkbox && isDesktop()) {
      queueForm(checkbox.closest('[data-es-native-filter-form]'), 150);
      return;
    }

    var rangeInput = event.target.closest('[data-es-price-min], [data-es-price-max]');
    if (rangeInput && isDesktop()) {
      updatePriceRange(rangeInput.closest('[data-es-price-range]'), rangeInput);
      queueForm(rangeInput.closest('[data-es-native-filter-form]'), 240);
    }
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-es-native-filter-form]');
    if (!form) return;
    event.preventDefault();
    closeMobileFilterOverlay();
    navigate(buildFormUrl(form), { push: true, scrollResults: true });
  });

  // The uncovered right-side gutter is the global overlay. Closing on pointerdown
  // makes the drawer respond immediately on iOS instead of waiting for a delayed click.
  document.addEventListener('pointerdown', function (event) {
    var overlay = event.target.closest && event.target.closest('.overlay-filter');
    if (!overlay || !document.querySelector('.filter-to-left.active')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    closeMobileFilterOverlay(document.querySelector('.js_filter'));
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    var openFrameHelp = document.querySelector('[data-es-frame-width-help-panel]:not([hidden])');
    if (openFrameHelp) {
      event.preventDefault();
      event.stopImmediatePropagation();
      closeFrameWidthHelp(openFrameHelp, true);
      return;
    }

    if (!document.querySelector('.filter-to-left.active')) return;
    event.preventDefault();
    closeMobileFilterOverlay(document.querySelector('.js_filter'));
  });

  document.addEventListener('click', collectionClickCapture, true);

  window.addEventListener('popstate', function () {
    if (!document.querySelector('.collection-page-fullwidth')) return;
    navigate(new URL(window.location.href), { push: false, scrollProducts: false });
  });

  window.addEventListener('resize', function () {
    var desktop = isDesktop();
    if (lastDesktopState !== desktop) {
      lastDesktopState = desktop;
      if (desktop) {
        closeMobileFilterOverlay();
        restoreSidebarHidden();
        restoreGroupStates();
      } else {
        document.documentElement.classList.remove('es-filters-hidden');
        restoreGroupStates();
        syncMobileFilterDrawerState();
      }
    }
    updateDesktopSidebarHeight();
    updateAllMobileActiveFilterOverflow();
  });

  window.addEventListener('scroll', updateDesktopSidebarHeight, { passive: true });
  window.addEventListener('pageshow', function () {
    cancelResultsPositioning();
    window.clearTimeout(collectionRequestFailSafe);
    collectionRequestFailSafe = null;
    activeController = null;
    setLoading(false);
    closeMobileFilterOverlay();
    initMobileActiveFilterOverflow(document);
  });

  window.addEventListener('pagehide', function () {
    cancelResultsPositioning();
    window.clearTimeout(collectionRequestFailSafe);
    collectionRequestFailSafe = null;
    if (activeController && activeController.abort) {
      try { activeController.abort(); } catch (e) {}
    }
    abortPriceUniformAudits();
  });

  function init() {
    lastDesktopState = isDesktop();
    setLoading(false);
    closeMobileFilterOverlay();
    initCollectionUi();
    var initialRoot = document.querySelector('.collection-page-fullwidth');
    if (initialRoot) schedulePostRefreshEnhancements(initialRoot);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
